<template>
  <div class="status">
    <span :class="[statusInfo ? 'active' : '', 'circle']"></span>
    {{statusInfoState}}
  </div>
</template>

<script>
export default {
  props: {statusInfo: {type: String}},
  computed: {
    statusInfoState: function() {
      return this.statusInfo ? 'Active' : 'Inactive'
    }
  }
}
</script>

<style lang="sass">
@import '../../styles/base/_variables.sass'

.status
  display: flex
  justify-content: space-between
  align-items: center
  color: $color-text-invert

  .circle
    display: inline-block
    width: 1rem
    height: 1rem
    margin-right: 1rem
    background-color: $color-error
    border-radius: 50%

  .active
    background-color: $color-no-error
</style>



// WEBPACK FOOTER //
// ../raypro_ui/src/components/ui/Status.vue